import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-773ab59b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewTimeSlotZoneForm" }
const _hoisted_2 = { class: "NewTimeSlotZoneForm__header" }
const _hoisted_3 = { class: "font-semibold select-none" }
const _hoisted_4 = { class: "NewTimeSlotZoneForm__content" }
const _hoisted_5 = {
  key: 0,
  class: "mt-16 select-none text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_color_picker = _resolveComponent("color-picker")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.modalTitle), 1),
      _createElementVNode("i", {
        class: "fas fa-times cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_new_input, {
        placeholder: "Название сектора тайм-слотов",
        disabled: _ctx.isSectorAdded || _ctx.loading,
        value: _ctx.state.name,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.name) = $event)),
        "is-invalid": _ctx.state_form$.name.$error,
        "validation-errors": _ctx.state_form$.name.$errors
      }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
      _createVNode(_component_new_select, {
        class: "mt-4",
        placeholder: "Диспетчерский сектор",
        disabled: _ctx.isSectorAdded || _ctx.loading,
        options: _ctx.dispatcherSectors,
        value: _ctx.state.dispatcherSectorId,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.dispatcherSectorId) = $event)),
        "is-invalid": _ctx.state_form$.dispatcherSectorId.$error,
        "validation-errors": _ctx.state_form$.dispatcherSectorId.$errors
      }, null, 8, ["disabled", "options", "value", "is-invalid", "validation-errors"]),
      _createVNode(_component_color_picker, {
        class: "mt-4 w-full",
        disabled: _ctx.isSectorAdded || _ctx.loading,
        value: _ctx.state.color,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.color) = $event)),
        onChange: _ctx.onChangeColor
      }, null, 8, ["disabled", "value", "onChange"]),
      (_ctx.isRenderingOnPaint)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Обведите область на карте "))
        : _createCommentVNode("", true),
      (_ctx.isRenderingStartPaint)
        ? (_openBlock(), _createBlock(_component_new_button, {
            key: 1,
            class: "mt-16",
            disabled: _ctx.isSectorAdded || _ctx.loading,
            onClick: _ctx.onStartPaint
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Обвести область ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isRenderingSubmit)
        ? (_openBlock(), _createBlock(_component_new_button, {
            key: 2,
            class: "mt-16",
            loading: _ctx.loading,
            disabled: _ctx.loading,
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.buttonTitle), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_new_button, {
        class: "NewButton--outline mt-3",
        disabled: _ctx.loading,
        onClick: _ctx.onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Отмена ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}